module.exports = __webpack_public_path__ + "img/almatyObl2.a49c06a1.jpg";